"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAreaResizeEnum = exports.TextAreaBackgroundEnum = exports.TextArea = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var React = _interopRequireWildcard(require("react"));
var _reactUid = require("react-uid");
var _controlContainer = require("./controlContainer");
var _rawTextArea = require("./rawControls/rawTextArea");
var colors = _interopRequireWildcard(require("wnd-themes/lib/colorPalette"));
var _iconTypes = require("../../styles/icon-types");
var _rawTextArea2 = require("./rawControls/rawTextArea.styles");
var _HelperText = require("./helpers/HelperText");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TextAreaResizeEnum;
(function (TextAreaResizeEnum) {
  TextAreaResizeEnum["None"] = "none";
  TextAreaResizeEnum["Both"] = "both";
  TextAreaResizeEnum["Horizontal"] = "horizontal";
  TextAreaResizeEnum["Vertical"] = "vertical";
  TextAreaResizeEnum["Initial"] = "initial";
  TextAreaResizeEnum["Inherit"] = "inherit";
})(TextAreaResizeEnum || (exports.TextAreaResizeEnum = TextAreaResizeEnum = {}));
var TextAreaBackgroundEnum;
(function (TextAreaBackgroundEnum) {
  TextAreaBackgroundEnum["Transparent"] = "transparent";
})(TextAreaBackgroundEnum || (exports.TextAreaBackgroundEnum = TextAreaBackgroundEnum = {}));
const TextArea = exports.TextArea = /*#__PURE__*/React.forwardRef(({
  id,
  autoComplete,
  className,
  hasError,
  label,
  maxLength,
  name,
  onChange,
  onBlur,
  placeholder,
  readOnly,
  value,
  disabled,
  defaultValue,
  required,
  validationErrorId,
  resize,
  hasNotepadLines,
  skipScroll,
  helperText,
  small
}, ref) => {
  const inputId = (0, _reactUid.useUID)();
  const INITIAL_NOTEPAD_OFFSET = 0.6;
  const [notepadOffset, setNotepadOffset] = React.useState(INITIAL_NOTEPAD_OFFSET);
  const [notepadHeight, setNotepadHeight] = React.useState(0);
  const inputRef = React.useRef();
  React.useEffect(() => {
    if (hasNotepadLines && inputRef.current) {
      setNotepadHeight(inputRef.current.offsetHeight / 10);
    }
  }, [hasNotepadLines]);
  const onScroll = React.useCallback(e => {
    setNotepadOffset(INITIAL_NOTEPAD_OFFSET - e.target.scrollTop / 10);
    setNotepadHeight(e.target.clientHeight / 10);
  }, []);
  return (0, _jsxRuntime.jsxs)(_controlContainer.ControlContainer, {
    className: className,
    disabled: disabled,
    hasError: hasError,
    label: label,
    required: required,
    inputId: id ?? inputId,
    inputRef: inputRef,
    children: [(0, _jsxRuntime.jsx)(_rawTextArea.RawTextArea, {
      id: id ?? inputId,
      autoComplete: autoComplete,
      hasError: hasError,
      maxLength: maxLength,
      name: name,
      onChange: onChange,
      onBlur: onBlur,
      onScroll: onScroll,
      placeholder: placeholder,
      readOnly: readOnly,
      ref: ref,
      value: value,
      disabled: disabled,
      defaultValue: defaultValue,
      resize: hasNotepadLines ? TextAreaResizeEnum.None : resize,
      required: required,
      validationErrorId: helperText ? `${id ?? inputId}-description` : validationErrorId,
      skipBorder: hasNotepadLines,
      skipScroll: hasNotepadLines || skipScroll,
      background: hasNotepadLines ? TextAreaBackgroundEnum.Transparent : undefined,
      insetIcon: hasError ? _iconTypes.Icons.Warning : undefined,
      iconColor: colors.validationErrorRed,
      small: small
    }), hasNotepadLines && (0, _jsxRuntime.jsx)(_rawTextArea2.TextAreaNotepadLines, {
      offset: notepadOffset,
      height: notepadHeight
    }), helperText && (0, _jsxRuntime.jsx)(_HelperText.HelperText, {
      disabled: disabled,
      hasError: hasError,
      inputId: id ?? inputId,
      children: helperText
    })]
  });
});
TextArea.displayName = 'TextArea';